import { ReactComponent as LinkArrow } from 'src/assets/services-arrow-btn-2.svg';
import Banner from 'src/components/banner/banner';
import { BANNER_TYPE } from 'src/constants/banner-type';
import css from './general.module.scss';
import NewsBlock from './news-block/news-block';
import Menu from './menu/menu';
import SelectedMaterials from './selected-materials/selected-materials';
import EventsSection from './events/events-section';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import VacanciesWrapper from './vacancies/vacancies-wrapper';
import RequestEmailModal from 'src/components/request-modal/request-email-modal';

export default function General() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('slug')) {
      searchParams.delete('slug');
      setSearchParams();
    }
  }, [searchParams, setSearchParams]);
  return (
    <main className={css.general}>
      <NewsBlock />
      <Menu />
      <SelectedMaterials />
      <EventsSection />
      <VacanciesWrapper />

      <Banner bannerType={BANNER_TYPE.generalPartners}>
        <h1>Хочу бути На Зв’язку</h1>
        <div className={css.subTitleGroup}>
          <p className={css.subTitle}>
            Долучайтесь до платформи, щоб надати необхідну підтримку і допомогти захисникам та їхнім родинам
          </p>
        </div>
        <RequestEmailModal
          title='Запропонувати партнерство'
          trigger={
            <button id={css.partnerBanner} className={css.button}>
              <p>Запропонувати партнерство</p>
              <LinkArrow className={css.arrow} />
            </button>
          }
        />
      </Banner>
    </main>
  );
}
